class DynamicSettings {
    private apiUrl: string = "/api/DynamicSettings/GetPageSettings";
    private pageSettings: any = null;

    constructor() {
        this.init();
    }

    private async init(): Promise<void> {
        const currentUrl = window.location.href;
        const settings = await this.fetchPageSettings(currentUrl);

        if (settings) {
            this.pageSettings = settings.page;
            this.pageSettings.elements = settings.elements;
            this.injectStyles();
            this.createSettingsIcon(this.pageSettings.position);
        }
    }

    private async fetchPageSettings(url: string): Promise<any | null> {
        try {
            const response = await fetch(`${this.apiUrl}?url=${encodeURIComponent(url)}`, {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                }
            });

            if (!response.ok) {
                console.warn("No settings found for URL:", url);
                return null;
            }

            const data = await response.json();
            console.log(data)
            return data;
        } catch (error) {
            console.error("Error fetching page settings:", error);
            return null;
        }
    }


    private injectStyles(): void {
        const style = document.createElement("style");
        style.id = "dynamic-settings-style";
        style.innerHTML = `
        .dynamic-settings-icon {
            position: fixed;
            cursor: pointer;
            z-index: 9999;
            font-size: 20px;
            background-color: white;
            border: 1px solid #ccc;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        }
        .dynamic-settings-modal {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: white;
            padding: 20px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.3);
            z-index: 10000;
            border-radius: 8px;
            width: 800px;
            height: 600px;
            max-width: 95%;
            display: flex;
            flex-direction: row;
        }

        .dynamic-settings-sidebar {
            width: 200px;
            border-right: 1px solid #ddd;
            padding-right: 10px;
            overflow-y: auto;
        }
        .dynamic-settings-content {
            flex-grow: 1;
            padding-left: 10px;
            overflow-y: auto;
        }
        .dynamic-settings-sidebar button {
            width: 100%;
            margin-bottom: 5px;
            padding: 10px;
            text-align: left;
            background-color: #f7f7f7;
            border: 1px solid #ddd;
            cursor: pointer;
        }
        .dynamic-settings-sidebar button:hover {
            background-color: #e7e7e7;
        }
    `;
        document.head.appendChild(style);
    }


    private createSettingsIcon(position: any): void {
        const iconWrapper = document.createElement("div");
        iconWrapper.className = "dynamic-settings-icon";

        const faIcon = document.createElement("i");
        faIcon.className = "fas fa-cog"; // Font Awesome 'cog' icon

        iconWrapper.appendChild(faIcon);

        if (position.top) {
            if (position.topValueInPixel) {
                iconWrapper.style.top = `${position.topValue}px`;
            } else {
                iconWrapper.style.top = `${position.topValue}%`;
            }
        } else {
            iconWrapper.style.bottom = "20px";
        }

        if (position.left) {
            if (position.leftValueInPixel) {
                iconWrapper.style.left = `${position.leftValue}px`;
            } else {
                iconWrapper.style.left = `${position.leftValue}%`;
            }
        } else {
            iconWrapper.style.right = "20px";
        }

        iconWrapper.addEventListener("click", () => this.openModal());

        document.body.appendChild(iconWrapper);
    }


    private openModal(): void {
        let wrapper = document.getElementById("dynamic-settings-modal-wrapper");

        if (!wrapper) {
            wrapper = document.createElement("div");
            wrapper.id = "dynamic-settings-modal-wrapper";
            wrapper.style.position = "fixed";
            wrapper.style.top = "0";
            wrapper.style.left = "0";
            wrapper.style.width = "100%";
            wrapper.style.height = "100%";
            wrapper.style.backgroundColor = "rgba(0,0,0,0.5)";
            wrapper.style.zIndex = "9998";
            wrapper.style.display = "flex";
            wrapper.style.alignItems = "center";
            wrapper.style.justifyContent = "center";

            document.body.appendChild(wrapper);

            // Now create modal INSIDE wrapper
            const modal = document.createElement("div");
            modal.id = "dynamic-settings-modal";
            modal.className = "dynamic-settings-modal";

            const sidebar = document.createElement("div");
            sidebar.className = "dynamic-settings-sidebar";
            sidebar.id = "dynamic-settings-sidebar";

            const content = document.createElement("div");
            content.className = "dynamic-settings-content";
            content.id = "dynamic-settings-content";

            modal.appendChild(sidebar);
            modal.appendChild(content);

            wrapper.appendChild(modal); // important: append modal INSIDE wrapper!

            // Create the Close button
            const closeButton = document.createElement("button");
            closeButton.id = "dynamic-settings-close-button";
            closeButton.textContent = this.pageSettings.modalInfo?.close_button || "Close";
            closeButton.style.position = "absolute";
            closeButton.style.top = "10px";
            closeButton.style.right = "10px";
            closeButton.style.zIndex = "10001";
            closeButton.style.padding = "8px 12px";
            closeButton.style.cursor = "pointer";

            closeButton.addEventListener("click", () => this.closeModal());

            modal.appendChild(closeButton);

            // Handle clicking outside the modal
            if (this.pageSettings.modalInfo?.allow_close_outside) {
                wrapper.addEventListener("click", (e) => {
                    if (e.target === wrapper) {
                        this.closeModal();
                    }
                });
            }

            if (this.pageSettings && this.pageSettings.categories) {
                const sidebarEl = document.getElementById("dynamic-settings-sidebar");
                this.pageSettings.categories.forEach((category: any, index: number) => {
                    const button = document.createElement("button");
                    button.textContent = category.name;
                    button.addEventListener("click", () => this.loadCategory(category));
                    sidebarEl?.appendChild(button);

                    if (index === 0) {
                        this.loadCategory(category);
                    }
                });
            }
        }
    }

    private attachAjaxPost(container: HTMLElement): void {
        const forms = container.querySelectorAll('form.ajax-post');

        forms.forEach(form => {
            const hasAutoReload = form.classList.contains('autoreload');
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                const formData = new FormData(form as HTMLFormElement);
                const action = (form as HTMLFormElement).action;
                const method = (form as HTMLFormElement).method || "POST";

                fetch(action, {
                    method: method.toUpperCase(),
                    body: formData
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Failed to save settings.');
                        }
                        return response.text();
                    })
                    .then(data => {
                        if (hasAutoReload) {
                            window.location.reload();
                        } else {

                            const successMessage = document.createElement('div');
                            successMessage.className = "alert alert-success mt-2";
                            successMessage.innerText = "Indstillinger gemt!";
                            form.appendChild(successMessage);

                            setTimeout(() => {
                                successMessage.remove();
                            }, 2000);

                        }
                    })
                    .catch(error => {
                        console.error('Error saving settings:', error);
                        alert('Fejl ved gemning af indstillinger.');
                    });
            });
        });
    }


    private closeModal(): void {
        const wrapper = document.getElementById("dynamic-settings-modal-wrapper");
        wrapper?.remove();
    }


    private loadCategory(category: any): void {
        const content = document.getElementById("dynamic-settings-content");
        if (!content) return;
        content.innerHTML = "";

        category.element_ids.forEach((elementId: string) => {
            const elementData = this.findElementById(elementId);
            if (elementData) {
                const section = document.createElement("div");
                section.style.marginBottom = "20px";

                const title = document.createElement("h3");
                title.textContent = elementData.label;
                section.appendChild(title);

                const partialContainer = document.createElement("div");
                partialContainer.id = `partial-${elementData.id}`;

                // Load the partial view
                this.loadPartialView(elementData.partialView, elementData.label, partialContainer);

                section.appendChild(partialContainer);
                content.appendChild(section);
            }
        });
    }

    private async loadPartialView(partialViewName: string, loadName: string, container: HTMLElement): Promise<void> {
        try {
            const response = await fetch(`/admin/DynamicSettings/Load${loadName}Partial?viewName=${partialViewName}`);
            if (!response.ok) {
                container.innerHTML = "<p style='color:red;'>Failed to load partial view.</p>";
                return;
            }
            const html = await response.text();
            container.innerHTML = html;
            this.attachAjaxPost(container);
        } catch (error) {
            console.error("Error loading partial view:", error);
            container.innerHTML = "<p style='color:red;'>Error loading partial view.</p>";
        }
    }



    private findElementById(id: string): any {
        if (!this.pageSettings || !this.pageSettings.elements) return null;
        return this.pageSettings.elements.find((el: any) => el.id === id);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new DynamicSettings();
});
